import { css } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'

import { StarIcon } from '@emico/icons'
import { overrideOptional } from '@emico/overrides'
import { theme } from '@emico/styles'

export interface RatingProps {
  stars?: number
  value: number
  className?: string
}

const StyledRating = styled.div`
  display: inline-block;
  position: relative;
`

const Background = styled.div`
  display: flex;
`

const ActiveStars = styled.div`
  display: flex;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
`

export const RatingStar = overrideOptional(styled(StarIcon)`
  width: 1em;
  height: 1em;
  flex-shrink: 0;
`)

export const RatingBackgroundStar = overrideOptional(styled(RatingStar)`
  color: ${theme.grayColor};
`)

export const RatingActiveStar = overrideOptional(styled(RatingStar)`
  color: ${theme.primaryColor};
`)

const Rating = ({ stars = 5, value, className }: RatingProps) => {
  const backgroundStars = []

  for (let i = 0; i < stars; i += 1) {
    backgroundStars.push(<RatingBackgroundStar key={i} />)
  }

  const activeStars = backgroundStars.map((_, i) => (
    <RatingActiveStar key={i} />
  ))

  return (
    <StyledRating className={className}>
      <Background>{backgroundStars}</Background>
      <ActiveStars
        css={css`
          width: ${(value / stars) * 100}%;
        `}
      >
        {activeStars}
      </ActiveStars>
    </StyledRating>
  )
}

export default overrideOptional(Rating)
